var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.00033 10.6637V13.997H1.66699",
    stroke: "#171717",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 7.3304V3.99707H18.3333",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.2094 3.99487C16.3588 5.19233 17.0607 6.74909 17.1972 8.4033C17.3336 10.0575 16.8962 11.7082 15.9586 13.0779C15.0209 14.4475 13.6402 15.4524 12.0487 15.9236C10.4572 16.3948 8.75189 16.3036 7.21973 15.6652",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.79094 13.9993C3.64403 12.8012 2.94428 11.245 2.80917 9.592C2.67407 7.93897 3.11184 6.28979 4.04899 4.92139C4.98613 3.55299 6.36557 2.54871 7.95567 2.07718C9.54576 1.60565 11.2497 1.69559 12.7813 2.3319",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.183a3ad21f7ba2306f1978399f02a81f.svg";
export { ForwardRef as ReactComponent };